<template>
  <div class="history">
    <div class="sub-title">
      <span></span>
      今天
    </div>
    <template v-if="today.length">
      <history-item v-for="(item, index) in today" :item="item" :key="index + item.id"></history-item>
    </template>
    <van-empty v-else description="暂无"></van-empty>
    <div class="sub-title">
      <span></span>
      昨天
    </div>
    <template v-if="yesterday.length">
      <history-item v-for="(item, index) in yesterday" :item="item" :key="item.id + index"></history-item>
    </template>
    <van-empty v-else description="暂无"></van-empty>
    <div class="sub-title">
      <span></span>
      更早
    </div>
    <template v-if="other.length">
      <history-item v-for="(item, index) in other" :item="item" :key="index + item.id + index"></history-item>
    </template>
    <van-empty v-else description="暂无"></van-empty>
    <!-- <Back /> -->
  </div>
</template>

<script>
import {getHistory} from '@/api'
import historyItem from './historyItem'
export default {
  components: {
    historyItem
  },
  data() {
    return {
      other: [],
      today: [],
      yesterday: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      getHistory().then(res => {
        const {other, today, yesterday} = res.data
        this.other = other
        this.today = today
        this.yesterday = yesterday
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.history {
  padding: 14px 16px;
}
.sub-title {
  position: relative;
  color: #303133;
  font-size: 14px;
  display: flex;
  align-items: center;
  font-weight: 700;
  margin-top: 20px;
  span {
    display: inline-block;
    width: 4px;
    height: 16px;
    border-radius: 2px;
    background: #4465f3;
    margin-right: 6px;
  }
}
</style>
